export default "__VITE_ASSET__8eed0a5c__"